<template>
    <b-button
        id="coi-action-bar-create-return-btn"
        size="sm"
        variant="primary"
        @click="() => {modalState = true}"
        class="mr-1"
        :disabled="true"
        block
    >Rücksendung  
       <!-- :disabled="!isOwnCustomerOrder" -->
        <b-modal
            v-model="modalState"
            id="modal-import-rule-set"
            title="Rücksendung"
            @ok="submit()"
            size="md"
            :ok-disabled="!userConsent"
            cancel-title="abbrechen"
        ><!-- modal -->
            <b-form-checkbox
                id=  "checkbox-send-automatic-email"
                name="checkbox-send-automatic-email"
                v-model="payload.sendAutomaticEmail"
            >
                Automatisch generierte Email an Kunden senden.
            </b-form-checkbox>
            <br>
            <b-form-checkbox
                id="checkbox-user-consent"
                name="checkbox-user-consent"
                v-model="userConsent"
            >
                Ich hab den Artikel geprüft. Kunde hat das Anrecht auf ein Rücksendelabel.
            </b-form-checkbox>
        </b-modal>
    </b-button>
</template>
<script>
export default {
        props: ['customerOrder', 'orderStates', 'vendors', 'marketAccounts'],
        data() {
            return {
                modalState: false,
                userConsent: false,
                isOwnCustomerOrder: false,
                payload: {
                    customerOrder: null,
                    sendAutomaticEmail: false,
                    // ...
                }
            }
        },
        methods: {
            submit() {
                console.log("called submit");
                this.payload.customerOrderId = this.customerOrder.id;
                this.payload.customerOrderItemId = this.customerOrder.customerorderitems[0].id;
                console.log("payload: ", this.payload);
                axios.post('/customerorder/returnorder', this.payload).then( response => {
                    this.userConsent = false;
                    this.payload.sendAutomaticEmail = false;
                    const url  = this.window.URL.createObjectURL(new Blob([atob(response.data.label)]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `label_${response.data.shipmentId}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                }).catch( error => {
                    console.log(error);

                    if(error.response.status == 406)
                    {
                        alert( "Zu dieser Bestellung wurde bereits ein Rücksendelabel angefordert.");
                    }
                    else
                    {
                        alert("Vorgang ist fehlgeschlagen");
                    }
                    this.userConsent = false;
                }).catch( error => {
                    console.error(error);
                    alert(`unhandled error. ${JSON.stringify(error)}`);
                });
            },
            downloadToFile(filename, extension, dataBase64)
            {
                const url  = window.URL.createObjectURL(new Blob([btoa(dataBase64)]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${filename}.${extension}`);
                document.body.appendChild(link);
                link.click();
            }
        },
        created() {
            //only temporary solution
                this.payload.customerOrderId = this.customerOrder.id;
                this.isOwnCustomerOrder = (this.customerOrder.marketAccountId   <  1000)
                                       || (this.customerOrder.marketAccountId === 10000);
        }
}
</script>
